module.exports = __webpack_public_path__ + "static/img/course08.8c2addc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course08.jpg
// module id = 1xSO
// module chunks = 101